/**
 * Зеркало каталога пресет-ролей backend (role_presets.py PRESETS) для UI-пикера.
 *
 * Бэк НЕ отдаёт список пресет-ролей отдельным GET (пресеты — код-константы,
 * копируются в момент POST /from-preset). Чтобы «Создать из пресета» показал
 * человекочитаемый выбор роли-шаблона ДО создания, держим здесь лёгкое зеркало
 * `preset_code → [{ code, name, description }]` (тот же паттерн, что
 * RESOURCE_CATALOG-зеркало). Матрица не дублируется — она приезжает с бэка в
 * ответе POST /from-preset (источник истины остаётся в коде бэка).
 *
 * ⚠️ При изменении PRESETS/PRESET_VERSION на бэке — синхронить этот список
 * (только code+name+description, без матрицы). Код роли обязан совпадать с
 * `preset_role["code"]` (валидатор from-preset отвергает несуществующий).
 */
import { type PresetCode } from './rolesLogic';

export interface PresetRoleOption {
  code: string;
  name: string;
  description: string;
}

export const PRESET_ROLE_CATALOG: Record<PresetCode, PresetRoleOption[]> = {
  agroholding: [
    {
      code: 'holding_director',
      name: 'Директор холдинга',
      description: 'Полный доступ ко всем ресурсам, кроме управления ролями.',
    },
    {
      code: 'cluster_clevel',
      name: 'Руководитель кластера',
      description: 'CRUD операций/осмотров в своём кластере, чтение структуры и полей.',
    },
    {
      code: 'chief_agronomist',
      name: 'Главный агроном (настраиваемая)',
      description: 'CRUD агрономии по всей компании: осмотры, отчёты, операции, справочники.',
    },
    {
      code: 'field_agronomist',
      name: 'Агроном полей (настраиваемая)',
      description: 'Осмотры/отчёты/операции в своём хозяйстве; поля только чтение.',
    },
    {
      code: 'monitoring_office',
      name: 'Офис-мониторинг',
      description: 'Учётчик: чтение всего + ввод осмотров/операций.',
    },
    {
      code: 'lawyer',
      name: 'Юрист',
      description: 'Кадастр/структура на чтение, справочники на чтение.',
    },
    {
      code: 'observer',
      name: 'Наблюдатель',
      description: 'Только чтение всех ресурсов.',
    },
  ],
  kolkhoz: [
    {
      code: 'agronomist_wide',
      name: 'Агроном',
      description: 'Широкий CRUD по агрономии и операциям по всему хозяйству.',
    },
    {
      code: 'record_keeper',
      name: 'Учётчик',
      description: 'Ввод осмотров и операций, чтение полей/отчётов.',
    },
    {
      code: 'observer',
      name: 'Наблюдатель',
      description: 'Только чтение основных ресурсов.',
    },
  ],
};
